<template>
  <div>
    <!-- Stats Start -->
    <div class="row mb-4">
      <div class="col-md-2 d-flex align-items-center">
        <div>
          <h3 style="font-size: 16px; color: #4b4b4b">Customer Report</h3>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md period-button-container">
            <div>
              <button
                type="button"
                class="btn btn-lg w-100 period-button"
                @click="period = 'Today'"
                :class="{
                  'btn-pretty': period == 'Today',
                  'not-selected-button': period != 'Today',
                }"
                style="font-weight: normal; font-family: 'Inter', sans-serif"
              >
                Today
              </button>
            </div>
          </div>
          <div class="col-md period-button-container">
            <div>
              <button
                type="button"
                class="btn btn-lg w-100 period-button"
                @click="period = 'This Week'"
                :class="{
                  'btn-pretty': period == 'This Week',
                  'not-selected-button': period != 'This Week',
                }"
                style="font-weight: normal; font-family: 'Inter', sans-serif"
              >
                This Week
              </button>
            </div>
          </div>
          <div class="col-md period-button-container">
            <div>
              <button
                type="button"
                class="btn btn-lg w-100 period-button"
                @click="period = 'This Month'"
                :class="{
                  'btn-pretty': period == 'This Month',
                  'not-selected-button': period != 'This Month',
                }"
                style="font-weight: normal; font-family: 'Inter', sans-serif"
              >
                This Month
              </button>
            </div>
          </div>
          <div class="col-md period-button-container">
            <div>
              <button
                type="button"
                class="btn btn-lg w-100 period-button"
                @click="period = 'This Year'"
                :class="{
                  'btn-pretty': period == 'This Year',
                  'not-selected-button': period != 'This Year',
                }"
                style="font-weight: normal; font-family: 'Inter', sans-serif"
              >
                This Year
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div>
          <div v-if="isPeriodCustom" style="position: relative">
            <i class="fas fa-calendar prefix-icon"></i>
            <div class="prefix-input">
              <flat-pickr
                :config="rangePickr"
                placeholder="Select Periode"
                v-model="selected.date"
                class="flatpickr-inter"
              ></flat-pickr>
            </div>
          </div>
          <div @click="openFlatpickr" v-else>
            <button
              class="btn btn-elegant"
              style="
                height: 41.2px;
                font-size: 12px;
                position: absolute;
                width: calc(100% - 20px);
                padding: 8px 20px;
                color: #4b4b4b;
                font-family: 'Inter', sans-serif;
              "
            >
              <i class="fas fa-calendar"></i>
              &nbsp;&nbsp;&nbsp;Select Periode
            </button>
            <div class="hidden">
              <flat-pickr
                ref="flatpickr"
                :config="rangePickr"
                placeholder="Select Periode"
                v-model="selected.date"
                class="hidden flatpickr-inter"
              ></flat-pickr>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="part-number-dropdown-container">
          <div class="dropdown">
            <Multiselect
              class="customer-report-multiselect customer-report-multiselect-inter customer-report-multiselect-proxima"
              :options="filterOptions.products.map((x) => x.id)"
              :custom-label="(opt) => filterOptions.products.find((x) => x.id == opt).material_no"
              placeholder="Select Part Number"
              v-model="filter.product"
              select-label=""
              deselect-label=""
              selected-label=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Stats End -->

    <!-- Table Start -->
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="bg-white box-content scan-history-table-wrapper">
          <div v-if="tableLoading" class="text-center mt-3 mb-3">
            <h4>Loading...</h4>
          </div>

          <div v-else style="overflow-x: auto; overflow-y: hidden">
            <table class="table scan-history-table" style="margin: 0">
              <thead>
                <tr>
                  <th
                    v-for="(field, index) in fields"
                    :key="field.variable"
                    :style="
                      index === 0 ? 'padding-left: 20px; padding-top: 20px;' : 'padding-top: 20px;'
                    "
                  >
                    {{ field.title }}
                  </th>
                  <th style="text-align: left; padding-top: 20px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in tableData"
                  :key="`${row.id || row.qrcode || index}-${index}`"
                >
                  <td
                    v-for="(field, fieldIndex) in fields"
                    :key="field.variable"
                    :class="{ 'name-column': field.variable === 'product_name' }"
                    :style="fieldIndex === 0 ? 'padding-left: 20px;' : ''"
                  >
                    {{ row[field.variable] || "-" }}
                  </td>
                  <td style="text-align: left">
                    <img
                      v-for="button in buttons"
                      :key="button.title"
                      :src="button.icon"
                      :alt="button.title"
                      :title="button.title"
                      @click="handleButtonClick(button.title, row)"
                      style="width: 34px; height: 24px; margin: 0 4px; cursor: pointer"
                    />
                  </td>
                </tr>
                <tr v-if="!tableLoading && tableData.length === 0">
                  <td :colspan="fields.length + 1" class="text-center">No data available</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="row mt-3 pagination-divider"
            v-if="!tableLoading && (tableData.length > 0 || total > 0 || maxPage > 1)"
          >
            <div
              class="col-12 d-flex align-items-center justify-content-between flex-wrap mb-3 pl-3"
            >
              <div class="d-flex align-items-center">
                <span
                  class="view-per-page-text"
                  style="
                    margin-right: 8px;
                    color: #cbcbcb;
                    font-size: 14px;
                    font-weight: 400;
                    font-style: normal;
                  "
                >
                  View
                </span>
                <select
                  v-model.number="limitPerPage"
                  @change="onLimitChange"
                  class="form-control form-control-sm"
                  style="
                    width: auto;
                    display: inline-block;
                    padding: 4px 8px;
                    font-family: 'Inter', sans-serif;
                  "
                >
                  <option v-for="option in limitPerPageOptions" :key="option" :value="option">
                    {{ option }}
                  </option>
                </select>
                <span
                  class="view-per-page-text"
                  style="
                    margin-left: 8px;
                    color: #cbcbcb;
                    font-size: 14px;
                    font-weight: 400;
                    font-style: normal;
                  "
                >
                  items per page
                </span>
              </div>
              <div class="d-flex align-items-center flex-wrap">
                <p
                  class="mt-2 mb-2 view-per-page-text"
                  style="
                    color: #cbcbcb;
                    margin-right: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    font-style: normal;
                  "
                >
                  Showing Page {{ currentPage }}
                </p>
                <nav class="pagination-minimal">
                  <ul class="pagination" style="margin: 0; flex-wrap: wrap">
                    <li
                      class="page-item"
                      :class="{ disabled: currentPage <= 1 || tableLoading }"
                      @click.stop.prevent="changePage('prev')"
                    >
                      <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled:
                          tableLoading || (!hasMoreData && currentPage >= maxPage && maxPage !== 0),
                      }"
                      @click.stop.prevent="changePage('next')"
                    >
                      <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Table End -->

    <!-- Modal Start -->
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <div class="">
          <div class="row mb-2">
            <div class="col-9 mt-auto mb-auto">
              <span class="h4">Image Report</span>
            </div>
            <div class="col-3 mt-auto mb-auto">
              <span class="close" @click="closeModal"><i class="fa fa-times fa-xs"></i></span>
            </div>
          </div>
        </div>
        <div class="ahm-modal-body text-center">
          <img
            :src="selectedData.file"
            alt="modal-image"
            style="width: auto; height: 100%; max-height: 250px"
          />
        </div>
        <div class="text-left mt-3">
          <label class="ahm-modal-description">{{ selectedData.reason }}</label>
          <br />
          <label class="ahm-modal-description">{{ selectedData.description }}</label>
        </div>
      </div>
    </div>
    <!-- Modal End -->

    <Map
      title="Customer Report Location"
      v-if="mapData"
      @closeModal="mapData = null"
      :data="mapData"
    />
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import Multiselect from "vue-multiselect";
import debounce from "debounce";
import Map from "./children/Map.vue";

export default {
  metaInfo: {
    title: "Highlights",
  },
  components: {
    Multiselect,
    Map,
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.currentPage = 1;
        this.fetchData();
      },
    },
    "selected.date"() {
      this.debounceMethod("", this, "", "date");
    },
    period: function () {
      let start = null;
      let end = null;

      let inputString = this.period;
      if (Object.keys(this.periodContent).includes(inputString)) {
        start = this.periodContent[inputString].start.format("DD/MM/Y");
        end = this.periodContent[inputString].end.format("DD/MM/Y");

        this.isPeriodCustom = true;
        this.selected.date = `${start} to ${end}`;
      }
    },
  },
  computed: {
    hasMoreData() {
      return this.tableData.length === this.limitPerPage;
    },
  },
  created() {
    this.$http
      .get("/master/products")
      .then((resp) => {
        this.products = resp.data.data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  mounted() {
    this.fetchData();
  },
  data() {
    let startOfMonth = new moment().startOf("month");
    let endOfMonth = new moment().endOf("day");

    return {
      apiData: [],
      showModal: false,
      selectedImage: null,
      selectedData: null,
      statsData: null,
      totalRegister: 0,
      tpsData: null,
      activityData: null,
      invokeCenter: null,
      filterOptions: {
        products: this.$store.getters.getProducts,
      },
      filter: {
        product: null,
        start: startOfMonth.format("YYYY-MM-DD"),
        end: endOfMonth.format("YYYY-MM-DD"),
      },
      periodContent: {
        Today: {
          start: moment().startOf("day"),
          end: moment().endOf("day"),
        },
        "This Week": {
          start: moment().startOf("week"),
          end: moment().endOf("week"),
        },
        "This Month": {
          start: moment().startOf("month"),
          // end: moment().endOf('month'),
          end: moment().endOf("day"),
        },
        "This Year": {
          start: moment().startOf("year"),
          end: moment().endOf("year"),
        },
      },
      isPeriodCustom: true,
      period: "This Month",
      moment,
      rangePickr: {
        mode: "range",
        dateFormat: "d/m/Y",
        altInput: true,
        altFormat: "d/m/Y",
        altInputClass: "form-control input elegant-flatpickr flatpickr-inter-input",
      },
      selected: {
        // dateButtonsIndex : 2,
        date: `${startOfMonth.format("DD/MM/Y")} to ${endOfMonth.format("DD/MM/Y")}`,
        // topScanDate : `${startOfMonth} to ${endOfMonth}`
      },
      mapData: null,
      update: 0,
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      maxPage: 1,
      total: 0,
      limitPerPage: 10,
      limitPerPageOptions: [10, 25, 50, 100],
      fields: [
        {
          title: "QR Code",
          variable: "qrcode",
        },
        {
          title: "Tanggal Report",
          variable: "scan_date",
          // formatDate: (value) => moment(value).format('DD/MM/YYYY | HH:mm:ss')
          // formatDate: this.formatScanDate
        },
        {
          title: "Name",
          variable: "product_name",
        },
        {
          title: "Reason",
          variable: "reason",
        },
        {
          title: "Description",
          variable: "description",
        },
      ],
      buttons: [
        {
          title: "map",
          icon: require("@/assets/img/map_pin_icon.svg"),
        },
        {
          title: "image",
          icon: require("@/assets/img/image_icon.svg"),
        },
      ],
    };
  },
  methods: {
    formatScanDate(value) {
      return moment(value).format("DD/MM/YYYY | HH:mm:ss");
    },
    debounceMethod: debounce((value, vm, filterVar, selectedVar) => {
      let split = vm.selected[selectedVar].split(" to ");
      vm.filter.start = moment(split[0], "DD/MM/Y").format("Y-MM-DD");
      vm.filter.end =
        split.length > 1
          ? moment(split[1], "DD/MM/Y").format("Y-MM-DD")
          : moment(split[0], "DD/MM/Y").format("Y-MM-DD");
      vm.currentPage = 1;

      // Custom Period
      vm.isPeriodCustom = true;
      vm.period = "Custom";
      for (var i in vm.periodContent) {
        if (
          vm.periodContent[i].start.format("Y-MM-DD") == vm.filter.start &&
          vm.periodContent[i].end.format("Y-MM-DD") == vm.filter.end
        ) {
          vm.period = i;
          vm.isPeriodCustom = true;
          return;
        }
      }

      // vm[value]();
    }, 1500),
    async fetchData() {
      const params = {
        limit: this.limitPerPage,
        page: this.currentPage,
      };

      // Add filter params
      if (this.filter.product) {
        params.product = this.filter.product;
      }
      if (this.filter.start) {
        params.start = this.filter.start;
      }
      if (this.filter.end) {
        params.end = this.filter.end;
      }

      const queryString = qs.stringify(params, {
        skipNulls: true,
        encodeValuesOnly: true,
      });

      this.tableLoading = true;

      try {
        const resp = await this.$http.get(`/customer-report/list?${queryString}`);
        const data =
          (resp && resp.data && resp.data.data) || (resp && resp.data && resp.data.rows) || [];
        const meta =
          (resp && resp.data && resp.data.meta) ||
          (resp && resp.data && resp.data.pagination) ||
          resp.data ||
          {};

        this.tableData = Array.isArray(data) ? data : [];
        this.currentPage = meta.currentPage || meta.current_page || meta.page || this.currentPage;
        this.maxPage =
          meta.lastPage ||
          meta.last_page ||
          meta.totalPages ||
          meta.total_pages ||
          (this.tableData.length === this.limitPerPage ? this.currentPage + 1 : this.currentPage);
        this.total = meta.total || meta.totalItems || meta.total_count || 0;
      } catch (error) {
        console.error("Failed to fetch customer report:", error);
        this.tableData = [];
        this.currentPage = 1;
        this.maxPage = 1;
        this.total = 0;
      } finally {
        this.tableLoading = false;
      }
    },
    onLimitChange() {
      this.currentPage = 1;
      this.fetchData();
    },
    changePage(direction) {
      if (this.tableLoading) return;

      if (direction === "prev" && this.currentPage > 1) {
        this.currentPage -= 1;
        this.fetchData();
        return;
      }

      const hasNextPage = this.hasMoreData || (this.maxPage && this.currentPage < this.maxPage);

      if (direction === "next" && hasNextPage) {
        this.currentPage += 1;
        this.fetchData();
      }
    },
    handleButtonClick(buttonTitle, row) {
      // Find the button variable to get the data to pass
      const button = this.buttons.find((b) => b.title === buttonTitle);
      if (!button) return;

      // Get the data to pass (either from button.variable or the whole row)
      let dataToPass = row;
      if (button.variable && row[button.variable]) {
        dataToPass = row[button.variable];
      }

      // Emit the event similar to vue-universal-table
      if (buttonTitle.toLowerCase() === "image") {
        this.openModal(JSON.stringify(dataToPass));
      } else if (buttonTitle.toLowerCase() === "map") {
        this.showMap(JSON.stringify(dataToPass));
      }
    },
    openModal(data) {
      // console.log(imageUrl)
      try {
        data = JSON.parse(data);
      } catch (e) {
        console.log(e);
      }
      this.selectedData = data;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.selectedImage = null;
    },
    showMap(data) {
      console.log("Show Map Data");
      console.log(data);
      try {
        data = JSON.parse(data);
      } catch (e) {
        console.log(e);
      }
      this.mapData = data;
    },
    openFlatpickr() {
      this.$refs.flatpickr.fp.open();
    },
  },
};
</script>

<style scoped>
.btn-pretty {
  background-color: #dbebff;
  color: #267ce5;
  font-size: 12px !important;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.statsData {
  padding: 10px 7px;
}

.stats {
  font-size: 1.3rem;
  font-weight: 600;
}

.bg-kabupaten {
  background-color: darkorange;
}

.bg-kecamatan {
  background-color: blueviolet;
}

.bg-desakel {
  background-color: darkslategray;
}

.bg-tps {
  background-color: dodgerblue;
}

.column-region {
  height: 400px;
  overflow-y: scroll;
}
</style>

<style scoped>
.not-selected-button {
  color: #4b4b4b;
  background-color: #ffffff;
  border: none;
}

.horizontal-line {
  border-top: 1px solid #a2a2a2;
  margin: 5px 0;
  width: 100%;
  height: 1px;
}

.ahm-button-circular {
  width: 40px;
  /* Set the width and height to the same value for a perfect circle */
  height: 40px;
  border-radius: 50%;
  /* Makes the button circular */
  background-color: #d8e4ff;
  /* Sets the background color */
  padding: 10px 20px;
  /* Adjust padding to fit your content */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  outline: none;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  /* Adjust shadow values as needed */
}

.ahm-modal-description {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #2d2d2d;
  opacity: 1;
}

.ahm-modal-title {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #4b4b4b;
  opacity: 1;
}

.ahm-modal-body {
  /* Set a fixed width and height for the container, or use relative units like % if needed */
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* Hide any overflowing content */
}

.modal {
  display: block;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: hidden;
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.modal-content {
  background-color: #fefefe;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border: 1px solid #888;
  width: 45%;
  overflow: hidden;
  max-height: 80vh;
}

.close {
  color: black;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>

<style>
.ahm-table thead tr th {
  pointer-events: none;
}

.ahm-table thead tr th,
.table-title {
  font-weight: normal;
  color: #bcbcbc;
  text-align: left !important;
}

.ahm-table thead tr th,
.ahm-table tbody tr td {
  vertical-align: middle;
  font-size: 14px;
  text-align: left !important;
}

.ahm-table.ahm-table-cr thead tr th:last-child {
  text-align: center !important;
}

.ahm-table.ahm-table-cr tbody tr td:nth-last-child(2) {
  text-align: right !important;
}

.ahm-table .no-border td {
  border: 0;
  padding: 5px;
}

.ahm-table.table-sequre thead tr th {
  border-bottom: 1px solid #e8e8e8 !important;
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
  color: #4b4b4b !important;
  font-weight: normal !important;
}

.ahm-table.table-sequre tbody tr td {
  min-width: 0px;
  /* Adjust the width as needed */
}

.table td,
.table th {
  padding: 8px;
  vertical-align: top;
  border-top: 1px solid #e4e7ea;
}

.scan-history-table-wrapper .table.scan-history-table,
.scan-history-table-wrapper .table.scan-history-table th,
.scan-history-table-wrapper .table.scan-history-table td,
.scan-history-table-wrapper .table.scan-history-table thead,
.scan-history-table-wrapper .table.scan-history-table thead th,
.scan-history-table-wrapper .table.scan-history-table tbody,
.scan-history-table-wrapper .table.scan-history-table tbody td,
.scan-history-table-wrapper .table.scan-history-table tbody tr {
  font-family: "Inter", sans-serif !important;
}

.prefix-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.prefix-input .elegant-flatpickr {
  padding-left: 35px;
}

.hidden .elegant-flatpickr {
  opacity: 0;
  position: absolute;
  z-index: -1;
}

.customer-report-multiselect .multiselect__placeholder {
  color: black;
}

.box-content {
  border-radius: 10px;
}

.scan-history-table-wrapper.box-content {
  padding: 0;
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .scan-history-table thead th,
.scan-history-table-wrapper .scan-history-table tbody td {
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .scan-history-table thead,
.scan-history-table-wrapper .scan-history-table thead tr,
.scan-history-table-wrapper .scan-history-table thead th,
.scan-history-table-wrapper .scan-history-table tbody,
.scan-history-table-wrapper .scan-history-table tbody tr,
.scan-history-table-wrapper .scan-history-table tbody td {
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ffffff !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9d9d9d;
  text-align: left;
  vertical-align: middle !important;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  font-family: "Inter", sans-serif !important;
  padding-top: 20px;
  padding-bottom: 20px;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4b4b4b;
  text-align: left;
  vertical-align: middle;
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
  padding-top: 15px;
  padding-bottom: 15px;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td.name-column {
  color: #393939;
}

.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4b4b4b;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled) .page-link:hover {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9d9d9d !important;
}

.pagination-divider {
  border-top: 1px solid #e6e6e6;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 16px;
  overflow: hidden;
}

.view-per-page-text {
  font-family: "Inter", sans-serif !important;
  color: #cbcbcb;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
}

.flatpickr-inter .elegant-flatpickr,
.flatpickr-inter-input {
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  color: #4b4b4b !important;
}

.customer-report-multiselect-inter .multiselect__tags,
.customer-report-multiselect-inter .multiselect__single,
.customer-report-multiselect-inter .multiselect__placeholder {
  font-family: "Inter", sans-serif !important;
}

.customer-report-multiselect-proxima .multiselect__tags,
.customer-report-multiselect-proxima .multiselect__single,
.customer-report-multiselect-proxima .multiselect__placeholder {
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  color: #4b4b4b !important;
}

.period-button-container {
  width: 91px;
}

.period-button {
  font-size: 12px !important;
}

.period-button.not-selected-button {
  color: #4b4b4b !important;
}

.part-number-dropdown-container {
  width: 100%;
  max-width: 100%;
}

/* MultiSelect Chevron Icon */
.customer-report-multiselect,
.customer-report-multiselect-inter {
  position: relative;
  display: inline-block;
  width: 100%;
}

.customer-report-multiselect .multiselect__select,
.customer-report-multiselect-inter .multiselect__select {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 100%;
  padding: 0;
  margin: 0;
  text-align: center;
  border-left: none;
  z-index: 1;
}

.customer-report-multiselect .multiselect__select:before,
.customer-report-multiselect-inter .multiselect__select:before {
  display: none !important;
}

.customer-report-multiselect .multiselect__select:after,
.customer-report-multiselect-inter .multiselect__select:after {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 7px;
  height: 4px;
  background-image: url("~@/assets/img/multiselect-chevron.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
  transition: transform 0.2s ease;
}

.customer-report-multiselect .multiselect--active .multiselect__select:after,
.customer-report-multiselect-inter .multiselect--active .multiselect__select:after {
  transform: translateY(-50%) rotate(180deg);
}

.customer-report-multiselect .multiselect__tags,
.customer-report-multiselect-inter .multiselect__tags {
  padding-right: 40px;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}
</style>
